import { useTranslation } from 'react-i18next'
import QRCode from 'react-qr-code'

const HeaderSection = ({ data, hasCoolingMedicines, shouldSplitCoolingMedicinesToSeparateReceipt, isNeedCooling }) => {
    const { t } = useTranslation()
    return (
        <div className="d-flex justify-content-between pb-2">
            <div className="">
                <p className="pdf-header fs-2">
                    {data.isManual ? t("pharmacyRecept") : t("medicinesDeliveryRecept")}
                </p>
                <div className="fw-bolder fs-2"> {data.hospital}</div>
                <div className="fw-bolder fs-3  my-3"> {hasCoolingMedicines && t("coolingMedicinesInstruction")}</div>
                <p className="pdf-header fs-2">{t("requsetdate-print")}: {data.requestDate?.split("T")[0]}</p>
                {data?.attachedToRequestId &&
                    <div className='fs-3'>
                        <p className="card-name m-0">
                            {t("attachedToRequestId")}
                        </p>
                        <p className="card-value">
                            #{data?.attachedToRequestId}
                        </p>
                    </div>
                }
                <p className="pdf-header fs-2">{t("area")}: {data?.patientArea ? data?.patientArea : "-"}</p>
            </div>
            <div className="px-3 text-center">
                <div style={{ maxWidth: 150, margin: "auto" }}>
                    <QRCode
                        size={256}
                        style={{ width: "100%", height: "auto" }}
                        value={String(data?.id)}
                        viewBox="0 0 256 256"
                    />
                    <p className="pdf-header fs-2 my-2">#{data?.id}
                        <span>
                            {shouldSplitCoolingMedicinesToSeparateReceipt
                                ? isNeedCooling ? "/2" : "/1" : ""}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HeaderSection